module.exports = __webpack_public_path__ + "static/media/Vendas6.a359a9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas6.png
// module id = 1776
// module chunks = 0